import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography, Button } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';

import styles from './styles';

const PanelHeaderActionButtons = ({ classes, editHandler, deleteHandler }) => {
  return (
    <div className={classes.titleHeadActions}>
      {typeof editHandler === 'function' && (
        <Button onClick={editHandler} startIcon={<ADGMImage name='edit-pencil-red.svg' alt='edit-pencil' />}>
          <Typography>{keyEmptyCheck('Edit')}</Typography>
        </Button>
      )}
      {typeof editHandler === 'function' && (
        <span>
          <ADGMImage name='DividerRed.svg' alt='divider' />
        </span>
      )}
      {typeof deleteHandler === 'function' && (
        <Button onClick={deleteHandler} startIcon={<ADGMImage name='delete-red-small.svg' alt='delete' />}>
          <Typography>{keyEmptyCheck('delete')}</Typography>
        </Button>
      )}
    </div>
  );
};

PanelHeaderActionButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  editHandler: PropTypes.func.isRequired,
  deleteHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(PanelHeaderActionButtons);
